/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（火曜日）
 * @export
 * @interface EnableOrderdayTue
 */
export interface EnableOrderdayTue {
}

/**
 * Check if a given object implements the EnableOrderdayTue interface.
 */
export function instanceOfEnableOrderdayTue(value: object): value is EnableOrderdayTue {
    return true;
}

export function EnableOrderdayTueFromJSON(json: any): EnableOrderdayTue {
    return EnableOrderdayTueFromJSONTyped(json, false);
}

export function EnableOrderdayTueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdayTue {
    return json;
}

export function EnableOrderdayTueToJSON(json: any): EnableOrderdayTue {
    return EnableOrderdayTueToJSONTyped(json, false);
}

export function EnableOrderdayTueToJSONTyped(value?: EnableOrderdayTue | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

